import React, { useEffect, useState } from "react";

import { Row, Col, Image, Tooltip, Button, Card, Rate, Alert, Space } from "antd";
import { ShowText, ShowTextContent } from "components/UI/Segment/UIHelper";
import CKETextContent from "views/Segments/CKETextContent/CKETextContent";
import { getParsedJSONObject } from "views/Segments/InteractiveHelpers";
import { fetchWithStream, getAIServiceBaseURL, getFromLS, getUniqueId, removeHTMLTagsFromText } from "lib/utils/helperMethods";
import MediaShow from "components/UI/Media/MediaShow";
import ReactPlayer from "react-player";
import parse from "html-react-parser";
import EnlargableImage from "components/UI/Image/EnlargableImage";
import { enabledFeaturesSelector, partnerNameSelector } from "views/Auth/Login/selector";
import { useSelector } from "react-redux";
import RenderHtml from "components/UI/RenderHtml/RenderHtml";
import { printModeSelector } from "views/Experiences/selector";
import { ImMagicWand } from "react-icons/im";
import axios from 'axios';
import { useTranslate } from "lib/MrTranslate/MrTranslate";
import MagicButton from "../GenerateAI/MagicButton";
import { PlusOutlined } from "@ant-design/icons";
import { printOptionsSelector } from "views/Experiences/selector";
import { isEmpty } from "lodash";
import RateAiResult from "../GenerateAI/RateAiResult";
import UseAISolutionsButton from "../GenerateAI/UseAISolutionButton";
import { aiModelSelector } from "views/Orgs/selector";


const TextAnswerExplanation = (props) => {
  console.log("TextAnswerExplanation props", props);
  const { segmentSettings, triggerStateUpdate, setRenderMath } = props;
  let {
    parsedJSONObject,
    createMode,
    answerMode,
    presentationMode,
    autoCheckMode,
  } = getParsedJSONObject(props);

  let answerExplanation;
  if (createMode) {
    answerExplanation = props.value || "";
  } else {
    answerExplanation = props.answer_explanation;
  }
  const mrIntl = useTranslate()
  const [state, setState] = useState(answerExplanation);
  const [stateUpdatedCount, setStateUpdatedCount] = useState(0);
  const partnerName = useSelector(partnerNameSelector());
  const printMode = useSelector(printModeSelector());
  const printOptions = useSelector(printOptionsSelector());
  const aiModel = useSelector(aiModelSelector());

  let customFields = props.formInstance && props.formInstance.getFieldValue(["custom_fields"]);


  const [explanationLoading, setExplanationLoading] = useState(false);
  const [showExplanationForm, setShowExplanationForm] = useState(true);
  const [streamData, setStreamData] = useState({
    showAIText: false,
    content: null
  })

  const enabledFeatures = useSelector(enabledFeaturesSelector());
  const [triggerCKEDataUpdate, setTriggerCKEDataUpdate] = useState()

  let content;
  if (presentationMode) {
    content = props.answer_explanation;
  } else {
    content = state;
  }

  useEffect(() => {
    if (setRenderMath) {
      setRenderMath(getUniqueId());
    }
  }, []);

  useEffect(() => {
    if (createMode) {
      if (props.onChange) {
        props.onChange(state);
      }
    }
  }, [stateUpdatedCount]);

  const saveState = (newState) => {
    setState(newState);
    setStateUpdatedCount((stateUpdatedCount) => stateUpdatedCount + 1);
  };

  const onTextChanged = (data) => {
    const newState = data;
    console.log("onTextChanged==>", data);
    saveState(newState);
  };

  const generateExplanation = async () => {
    setExplanationLoading(true)
    const token = getFromLS("token");

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    let dataToPost = {
      "solution_type": "solution",
      "question_content": removeHTMLTagsFromText(props.questionContent, true),
    }
    if(aiModel) {
      dataToPost.model = aiModel
    }
    try {
      const fetchOptions = {
        url: `${getAIServiceBaseURL()}/generate-solutions`,
        dataToPost: dataToPost,
        setLoading: setExplanationLoading,
        content: "",
        successCallback: (data, responseStatus) => {
          setStreamData((prevData) => ({
            showAIText: true,
            content: data,
            isStreaming: responseStatus !== "stop"
          }))
        },
        setTriggerCKEDataUpdate: setTriggerCKEDataUpdate
      }
      fetchWithStream(fetchOptions);

    } catch (error) {
      console.error(error);
    }
  }

  let finalRender = [];
  if (createMode && showExplanationForm) {
    if (enabledFeatures.generate_explanation_with_ai || process.env.REACT_APP_MODE === "development") {
      if(streamData.showAIText) {
        finalRender.push(
          <RenderHtml text={streamData.content} extraClassname={"text-streaming-box"} />
        )
      } else {
        finalRender.push(
          <CKETextContent
            ckeConfig={{
              autoFocus: true,
              triggerCKEDataUpdate: triggerCKEDataUpdate
            }}
            writingAssistantConfig={{
              enabled: content ? true : false,
            }}
            value={content}
            onChange={(data) => onTextChanged(data)}
          ></CKETextContent>
        );
      }
      finalRender.push(
      // <Tooltip title={mrIntl("TextAnswerExplanation.auto_generate_explanation")}>
        <div className="ai-generated-info-msg">
          <Alert
            showIcon
            type="info"
            message={mrIntl("TextAnswerExplanation.use_aigenerated_explanations_as_guides_review_and_adjust_to_match")}
          />
          <Space>
            {streamData.showAIText && (
              <>
                {!streamData.isStreaming && <RateAiResult generatedData={streamData.content} action="generate_solutions" />}
                <UseAISolutionsButton 
                  loading={streamData.isStreaming} 
                  onTextChanged={() => onTextChanged(streamData.content)}
                  setStreamData={setStreamData}
                  onClick={() => {
                    let newCustomFieldsObject =
                    customFields && typeof customFields === "object"
                        ? { ...customFields }
                        : {};
                    newCustomFieldsObject = {
                      ...newCustomFieldsObject,
                      ai_used: {
                        ...newCustomFieldsObject.ai_used,
                        answer_explanation: true,
                      },
                    };
                    props.formInstance.setFieldValue(["custom_fields"], newCustomFieldsObject);
                  }}
                />
                {/* <Button
                  type="primary"
                  shape="round"
                  loading={streamData.isStreaming}
                  style={{ marginRight: "5px" }}
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setStreamData((prevData) => ({
                      ...prevData,
                      showAIText: false,
                    }));
                    let newCustomFieldsObject =
                    customFields && typeof customFields === "object"
                        ? { ...customFields }
                        : {};
                    newCustomFieldsObject = {
                      ...newCustomFieldsObject,
                      ai_used: {
                        ...newCustomFieldsObject.ai_used,
                        answer_explanation: true,
                      },
                    };
                    props.formInstance.setFieldValue(["custom_fields"], newCustomFieldsObject);
                    onTextChanged(streamData.content);
                  }}>{mrIntl("Markscheme.use")}</Button> */}
              </>
            )}
            <MagicButton
              tooltipTitle={mrIntl("TextAnswerExplanation.auto_generate_explanation")}
              type="text"
              loading={explanationLoading}
              onClick={() => generateExplanation()}
              disabled={streamData.isStreaming}
            />
          </Space>
        </div>
        // {/* <Button loading={explanationLoading} icon={<ImMagicWand />} type="text" onClick={() => generateExplanation()} /> */}
      // </Tooltip>
    )
    } else {
      finalRender.push(
        <CKETextContent
          ckeConfig={{triggerCKEDataUpdate: triggerCKEDataUpdate}}
          value={content}
          onChange={(data) => onTextChanged(data)}
        ></CKETextContent>
      );
    }
  } else {
    if (content) {
      if(printMode) {
        if (printOptions.with_answer_explanation === "true") {
          finalRender = (<Card
            className="print-answer-explanation"
            style={{marginTop: "20px"}}
            title="Teacher's Explanation"
          >
           <RenderHtml style={{overflowY: "auto"}} text={content} />
          </Card>
          )
        } else {
          finalRender = (<></>)
        }
      } else {
        finalRender.push(
          <ShowText key={`show-answer-explanation`} className={`show-answer-explanation p-20 m-t-20 m-b-10`}>
            <RenderHtml text={content} />
            {/* <ShowTextContent
                dangerouslySetInnerHTML={{ __html: content }}
              ></ShowTextContent> */}
            {/* {partnerName === "osc" ? (
              parse(content, {
                replace: (item) => {
                  if (item.name == "img") {
                    console.log("item is img", item);
                    return <EnlargableImage {...item.attribs} />;
                  }
                },
              })
            ) : (
              <ShowTextContent
                dangerouslySetInnerHTML={{ __html: content }}
              ></ShowTextContent>
            )} */}
          </ShowText>
        );
      }
      
    }
  }

  return (
    <Row>
      <Col span={24}>{finalRender}</Col>
    </Row>
  );
};
export default TextAnswerExplanation;
